"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _EventoccurrenceItem = _interopRequireDefault(require("./EventoccurrenceItem"));
var _ContentFormatter = require("./../../common/Adapters/CMSAdapter/ContentFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-event-occurrence-list .bx--list-box__menu {\n  visibility: visible !important; }\n\n.sia-event-occurrence-list a {\n  text-decoration: none; }\n\n.sia-event-occurrence-list .event-occurrence-item .top {\n  display: flex;\n  gap: 16px; }\n\n.sia-event-occurrence-list .event-occurrence-item .bottom {\n  display: flex;\n  gap: 16px;\n  justify-content: space-between; }\n  .sia-event-occurrence-list .event-occurrence-item .bottom .name {\n    font-size: 20px;\n    display: inline; }\n  .sia-event-occurrence-list .event-occurrence-item .bottom .tags {\n    width: 412px;\n    max-width: 100%; }\n    .sia-event-occurrence-list .event-occurrence-item .bottom .tags .tag {\n      cursor: pointer; }\n\n.sia-event-occurrence-list .event-occurrence-item:hover {\n  background-color: #f4f4f4; }\n\n@media (max-width: 66rem) {\n  .sia-event-occurrence-list .event-occurrence-item .bottom {\n    flex-direction: column; } }\n";
  const fileName = "EventOccurrenceList_EventOccurrenceList";
  const element = document.querySelector("style[data-sass-component='EventOccurrenceList_EventOccurrenceList']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const EventOccurrenceList = _ref => {
  let {
    lang,
    translate,
    eventOccurrences,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-event-occurrence-list"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-border-01-top"
  }, eventOccurrences.map((eventsOccurrence, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_EventoccurrenceItem.default, _extends({}, (0, _ContentFormatter.formatAgendaItem)(eventsOccurrence, translate), {
      onClick: onClick,
      lang: lang,
      translate: translate
    })));
  })));
};
var _default = exports.default = EventOccurrenceList;